import {validationMixin} from 'vuelidate';
import {maxLength, minLength, required, sameAs} from 'vuelidate/lib/validators';
import {mapActions, mapGetters} from 'vuex';
import camelCase from 'lodash/camelCase'
import {seo} from '@/mixins/seo'

export default {
    name: 'change-password',
    mixins: [validationMixin, seo],
    data() {
        return {
            validationErrors: {},
            payload: {
                oldPassword: '',
                password: '',
                confirmPassword: ''
            },
            showOldPassword: false,
            showPassword: false,
            showRepeatPassword: false,
            symbolLength: 0,
            currentClass: 'default',
            currentText: '',
            lineWidth: null
        }
    },
    validations: {
        payload: {
            oldPassword: {
                required,
                maxLength: maxLength(30)
            },
            password: {
                required,
                maxLength: maxLength(30),
                minLength: minLength(10)
            },
            confirmPassword: {
                required,
                sameAsPassword: sameAs('password')
            },
        }
    },
    created() {
        this.seo.title = this.$t(camelCase(this.$route.name));
    },
    computed: {
        oldPasswordErrors() {
            let error = [];
            if (!this.$v.payload.oldPassword.$dirty) {
                return error;
            }
            if (!this.$v.payload.oldPassword.required) {
                error.push(this.$t('validationRequired'))
            }
            if (!this.$v.payload.oldPassword.maxLength) {
                error.push(this.$t('maxLengthField')
                    .replace(':field', this.$t('fieldPassword'))
                    .replace(':count', 30));
            }
            if (this.validationErrors.oldPassword) {
                this.validationErrors.oldPassword.forEach((row) => {
                    error.push(row);
                });
            }
            return error;
        },
        passwordErrors() {
            let error = [];
            if (!this.$v.payload.password.$dirty) {
                return error;
            }
            if (!this.$v.payload.password.required) {
                error.push(this.$t('validationRequired'))
            }
            if (!this.$v.payload.password.maxLength) {
                error.push(this.$t('maxLengthField')
                    .replace(':field', this.$t('fieldPassword'))
                    .replace(':count', 30));
            }
            if (!this.$v.payload.password.minLength) {
                error.push(this.$t('minLengthField')
                    .replace(':field', this.$t('fieldPassword'))
                    .replace(':count', 10));
            }
            if (this.validationErrors.password) {
                this.validationErrors.password.forEach((row) => {
                    error.push(row);
                });
            }
            return error;
        },
        confirmPasswordErrors() {
            let error = [];
            if (!this.$v.payload.confirmPassword.$dirty) {
                return error;
            }
            if (!this.$v.payload.confirmPassword.required) {
                error.push(this.$t('validationRequired'))
            }
            if (!this.$v.payload.confirmPassword.sameAsPassword) {
                error.push(this.$t('validationSameAs'));
            }
            if (this.validationErrors.confirmPassword) {
                this.validationErrors.confirmPassword.forEach((row) => {
                    error.push(row);
                });
            }
            return error;
        },
        isHasFieldsValues() {
            return this.payload.oldPassword === '' && this.payload.password === '' && this.payload.confirmPassword === ''
        },
        ...mapGetters({
            loadingUpdatePassword: 'userPassword/loadingUpdatePassword'
        })
    },
    methods: {
        ...mapActions({
            profileChangePassword: 'userPassword/PASSWORD_UPDATE'
        }),
        resetForm() {
            this.$v.$reset();
            this.payload.oldPassword = '';
            this.payload.password = '';
            this.payload.confirmPassword = '';
            this.symbolLength = 0;
            this.lineWidth = 0;
            this.currentText = ''
            this.validationErrors = {};
        },
        createFormData() {
            let data = new FormData();
            data.append('old_password', this.payload.oldPassword);
            data.append('password', this.payload.password);
            data.append('password_confirmation', this.payload.confirmPassword);
            data.append('_method', 'patch');
            return data
        },
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.validationErrors = {};
                this.profileChangePassword(this.createFormData()).then(() => {
                    this.resetForm();
                    this.$toasted.success(this.$t('successChangeProfilePassword'))
                }).catch(error => {
                    if (error.response.status === 422) {
                        const errors = error.response.data.validation;
                        const toCamelCase = {};
                        for (let i in errors) {
                            toCamelCase[camelCase(i)] = errors[i]
                        }
                        this.validationErrors = toCamelCase;
                    }
                });
            }
        },
        charCount() {
            this.symbolLength = this.payload.password.length;
            this.lineWidth = this.symbolLength * 5;

            if (this.symbolLength === 0) {
                this.currentClass = 'default';
                this.currentText = ''
            }

            if (this.symbolLength > 0 && this.symbolLength <= 9) {
                this.currentClass = 'dangerous';
                this.currentText = this.$t('dangerousPassword')
            }
            if (this.symbolLength > 9 && this.symbolLength < 15) {
                this.currentClass = 'medium';
                this.currentText = this.$t('mediumPassword')
            }
            if (this.symbolLength > 15) {
                this.currentClass = 'safe';
                this.currentText = this.$t('safePassword')
            }
        }
    }
}
